import script from "./FirstPdfPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FirstPdfPage.vue?vue&type=script&setup=true&lang=ts"

import "./FirstPdfPage.vue?vue&type=style&index=0&id=6a23f43c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a23f43c"]])

export default __exports__